import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles/createTheme";
import { shouldForwardProp } from "../../common/Common.style";
import theme from "../../theme";

type ReplyBubbleStyleProps = {
  isReplyPreview?: boolean;
};

export const HeaderWrapper = styled(Box, {
  shouldForwardProp: prop =>
    shouldForwardProp<ReplyBubbleStyleProps>(["isReplyPreview"], prop),
})<ReplyBubbleStyleProps>(({ isReplyPreview, theme }) => ({
  backgroundColor: `${(theme as Theme).palette.grey[300]}`,
  borderRadius: "4px 7px 7px 4px",
  display: "flex",
  width: "auto",
  cursor: isReplyPreview ? "default" : "pointer",
  pointerEvents: isReplyPreview ? "none" : ("auto" as "none" | "auto"),
}));

export const VerticalDivider = styled(Box)`
  background-color: ${({ theme }) => (theme as Theme).palette.divider};
  border-radius: 7px 0 0 7px;
  min-width: 4px;
  max-width: 4px;
  height: auto;
`;

export const HeaderComponent = styled(Box)`
  padding: 7px;
`;

export const NoReplyContent = styled(Box)`
  display: flex;
  align-items: center;
  gap: 5px;
  padding-left: 5px;
`;

export const TitleComponent = styled(Typography)`
  font-size: medium;
`;

export const BodyComponent = styled(Typography)`
  font-size: small;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-weight: 400;
`;

export const ReplyBubbleWrapper = styled(Box, {
  shouldForwardProp: prop =>
    shouldForwardProp<ReplyBubbleStyleProps>(["isReplyPreview"], prop),
})<ReplyBubbleStyleProps>(({ isReplyPreview }) => ({
  padding: "3px",
  display: "flex",
  flexDirection: "column",
  gap: isReplyPreview ? "2px" : 0,
}));

export const ImageContainer = styled(Box)`
  position: relative;
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  margin-right: 5px;
  overflow: hidden;
  cursor: pointer;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${theme.message?.replyBubbleMediaBackground ?? undefined};
    pointer-events: none;
  }
`;
